import { Badge } from "../../../../../../shared/components/badge/Badge";

const DataLibraryDocsField = ({
  code,
  name,
  description,
  dataType = "Numeric",
}) => {
  return (
    <div className="rounded-lg border p-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-lg font-medium">{code}</h3>
          <p className="text-sm text-muted-foreground">{name}</p>
        </div>
        <Badge variant="outline" className="px-2 py-1">
          {dataType}
        </Badge>
      </div>
      <p className="text-sm">{description}</p>
    </div>
  );
};

export default DataLibraryDocsField;
